/* eslint-disable array-callback-return */
import AsyncStorage from '@react-native-async-storage/async-storage';
import { DateTime } from 'luxon';
import { API } from '../../service/api';
import { TrainerActions } from '../reducers/trainerReducer';
import { UserActions } from '../reducers/userReducer';

export const login = (userData, navigation) => (dispatch) => {
  dispatch({ type: TrainerActions.TOGGLE_LOADER });
  API.post('/auth', {
    email: userData.email,
    senha: userData.pass,
    perfil: 'PROFISSIONAL',
  }).then(({ data }) => {
    if (data.success) {
      AsyncStorage.setItem('PROFILE', 'PROFISSIONAL');
      AsyncStorage.setItem('ID', data.data.id_profissional);
      dispatch({ type: TrainerActions.UPDATE_DATA, dataType: 'trainerData', dataValue: data.data });
      dispatch({ type: TrainerActions.UPDATE_DATA, dataType: 'isError', dataValue: false });

      navigation.navigate('Profile Trainer');
    }
  }).catch(() => {
    dispatch({ type: TrainerActions.TOGGLE_ERROR });
  }).finally(() => {
    dispatch({ type: TrainerActions.TOGGLE_LOADER });
  });
};

export const getPlanData = (id_colaborador, navigation) => (dispatch) => {
  API.post('/search/plano', {
    where: `id_plano IN ( SELECT id_plano FROM empresa e JOIN colaborador c ON e.id_empresa = c.id_empresa WHERE id_colaborador = '${id_colaborador}' )`,
  }).then(({ data }) => {
    dispatch({ type: TrainerActions.UPDATE_DATA, dataType: 'planData', dataValue: data.data[0] });
    dispatch({ type: TrainerActions.TOGGLE_LOADER });
    navigation.navigate('Profile Worker');
  });
};

export const getClasses = (id_profissional, isNextMonth = false) => async (dispatch) => {
  dispatch({ type: TrainerActions.UPDATE_DATA, dataType: 'classesData', dataValue: [] });
  dispatch({ type: TrainerActions.TOGGLE_LOADER });

  const thisMonth = DateTime.now().toFormat('yyyy-LL');
  const nextMonth = DateTime.now().plus({ months: 1 }).toFormat('yyyy-LL');
  // console.log(DateTime.utc(Number(thisYear), 5).toFormat('yyyy-LL'));
  const lastDayOfMonth = DateTime.now().daysInMonth;
  const lastDayOfNextMonth = DateTime.now().plus({ months: 1 }).daysInMonth;

  const query = `id_profissional = '${id_profissional}' 
AND ${isNextMonth
    ? `(data BETWEEN '${nextMonth}-01' AND '${nextMonth}-${lastDayOfNextMonth}')`
    : `(data BETWEEN '${thisMonth}-01' AND '${thisMonth}-${lastDayOfMonth}')`
} `;

  API.post('/search/aula', { where: query })
    .then((result1) => {
      const allClasses = result1.data.data;
      API.post('/search/profissional_aula', { where: `id_profissional = '${id_profissional}'` }).then((result2) => {
        const ratedClasses = result2.data.data;
        allClasses.forEach((_class, index) => {
          allClasses[index].rated = ratedClasses.findIndex((ratedClass) => ratedClass.id_aula === _class.id_aula) !== -1;
        });
        Promise.all(allClasses.map(async (aula) => {
          const aulaFormatada = await API.post('/search/empresa', { where: `id_empresa = '${aula.id_empresa}'` });
          return {
            ...aula,
            nome_empresa: aulaFormatada.data.data[0].nome,
          };
        })).then((_result) => dispatch({ type: TrainerActions.UPDATE_DATA, dataType: 'classesData', dataValue: _result }));
      });
    })
    .finally(() => {
      dispatch({ type: TrainerActions.TOGGLE_LOADER });
    });
};

export const confirmRating = (data, navigation) => (dispatch) => {
  const today = DateTime.now().minus({ hours: 3 }).toFormat('yyyy-LL-dd');
  API.post('/create/profissional_aula', { ...data, data_participacao: today })
    .then((response) => {
      if (response.data.success) {
        navigation.navigate('Class Data');
        dispatch(getClasses(data.id_profissional));
      }
    })
    .catch((error) => {
      console.log(error.response.data.error);
    });
};

export const getTrainers = (userState) => (dispatch) => {
  // const { userSignUp } = useSelector((state) => state.user);
  const {
    segunda, terca, quarta, quinta, sexta, sabado, domingo, horario, objetivo1, objetivo2, objetivo3,
  } = userState;
  let period;
  switch (horario) {
    case '00:00':
      period = 'horario_00_a_01';
      break;
    case '01:00':
      period = 'horario_01_a_02';
      break;
    case '02:00':
      period = 'horario_02_a_03';
      break;
    case '03:00':
      period = 'horario_03_a_04';
      break;
    case '04:00':
      period = 'horario_04_a_05';
      break;
    case '05:00':
      period = 'horario_05_a_06';
      break;
    case '06:00':
      period = 'horario_06_a_07';
      break;
    case '07:00':
      period = 'horario_07_a_08';
      break;
    case '08:00':
      period = 'horario_08_a_09';
      break;
    case '09:00':
      period = 'horario_09_a_10';
      break;
    case '10:00':
      period = 'horario_10_a_11';
      break;
    case '11:00':
      period = 'horario_11_a_12';
      break;
    case '12:00':
      period = 'horario_12_a_13';
      break;
    case '13:00':
      period = 'horario_13_a_14';
      break;
    case '14:00':
      period = 'horario_14_a_15';
      break;
    case '15:00':
      period = 'horario_15_a_16';
      break;
    case '16:00':
      period = 'horario_16_a_17';
      break;
    case '17:00':
      period = 'horario_17_a_18';
      break;
    case '18:00':
      period = 'horario_18_a_19';
      break;
    case '19:00':
      period = 'horario_19_a_20';
      break;
    case '20:00':
      period = 'horario_20_a_21';
      break;
    case '21:00':
      period = 'horario_21_a_22';
      break;
    case '22:00':
      period = 'horario_22_a_23';
      break;
    case '23:00':
      period = 'horario_23_a_00';
      break;

    default:
      period = '';
      break;
  }

  const query = {
    where: `id_profissional != '1'
  ${segunda ? 'and segunda = true' : ''}
  ${terca ? 'and terca = true' : ''}
  ${quarta ? 'and quarta = true' : ''}
  ${quinta ? 'and quinta = true' : ''}
  ${sexta ? 'and sexta = true' : ''}
  ${sabado ? 'and sabado = true' : ''}
  ${domingo ? 'and domingo = true' : ''}
  ${objetivo1 ? `and ${objetivo1.toLowerCase()} = true` : ''}
  ${objetivo2 ? `and ${objetivo2.toLowerCase()} = true` : ''}
  ${objetivo3 ? `and ${objetivo3.toLowerCase()} = true` : ''}

  and ${period} = true 
  and cd_status = 'AGENCIADO'`,
  };
  API.post('/search/profissional', query)
    .then((result) => {
      const trainerList = result.data.data;
      dispatch({ type: UserActions.SET_TRAINERS, trainerList });
    }).catch((error) => {
      console.log(error.response.data.error);
    });
};
// eslint-disable-next-line consistent-return
export const getDates = (days, mes) => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth();
  const daysMounth = new Date(year, month + 1, 0);
  // const week = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

  function addZero(num) {
    if (num <= 9) return `0${num}`;
    return num;
  }
  const tempData = [];
  for (let i = 0; i <= daysMounth.getDate(); i++) {
    const day = new Date(year, month, i);
    if (days[0] === day.getDay() || days[1] === day.getDay()) {
      tempData.push({
        date: `${addZero(day.getDate())}/${mes}`,
        fullDate: day,
      });
    }
    if (i === daysMounth.getDate()) {
      return tempData;
    }
  }
};
